import React, { useEffect, useRef, useState } from "react";
import "../CSS/sidebar.css";
import github from "../Images/github-circle.png";
import linkedin from "../Images/linkedin-circle.png";
import leetcode from "../Images/leetcode.png";
import profile from "../Images/profile.jpg";
import emailicon from "../Images/email.png";
import locationicon from "../Images/location.png";

function Sidebar({ sidebarstatus, setsidebar }) {
  const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
      const mediaQuery = window.matchMedia(query);

      const handleMediaChange = (event) => {
        setMatches(event.matches);
      };

      mediaQuery.addListener(handleMediaChange);
      setMatches(mediaQuery.matches);

      return () => {
        mediaQuery.removeListener(handleMediaChange);
      };
    }, [query]);

    return matches;
  };
  useEffect(() => {
    ismobileScreen
      ? (sidebar.current.style.width = "100%")
      : (sidebar.current.style.width = "400px");
    setsidebar(false);
  }, [sidebarstatus]);
  const sidebar = useRef(null);
  const ismobileScreen = useMediaQuery("(max-width: 420px)");
  const istablet = useMediaQuery("(max-width: 1470px)");
  return (
    <div ref={sidebar} className="sidebar">
      {istablet ? (
        <div className="sidebar-close-container">
          <button
            onClick={() => {
              sidebar.current.style.width = "0px";
            }}
          >
            X
          </button>
        </div>
      ) : (
        ""
      )}
      <div className="sidebar-content">
        <div>
          <div className="sidebar-uppercontent">
            <div className="sidebar-name">@Dev</div>
            <div className="sidebar-specialities namecolor fontbold">
              {" "}
              <div>Web Developer</div>
              <div>Data Science Enthusiast</div>
              <div>AI Enthusiast</div>
            </div>
          </div>
          <div className="profileimg">
            <img src={profile} alt="Profile Pic" />
          </div>
          <div className="sidebar-otherdetails">
            <div className="sidebar-fullname">Dev Reshamiya</div>
            <div>
              <img src={emailicon} alt="email" />{" "}
              <span>Reshamiyadev1234@gmail.com</span>
            </div>
            <div>
              <img src={locationicon} alt="location" />
              <span>Ahmedabad, Gujarat, India</span>
            </div>
          </div>
          <div>
            <a href="https://github.com/Dev2907">
              <img src={github} alt="github" className="logo" />
            </a>
            <a href="https://www.linkedin.com/in/dev-reshamiya/">
              <img src={linkedin} alt="linkedin" className="logo" />
            </a>
            <a href="https://leetcode.com/reshamiyadev1234/">
              <img src={leetcode} alt="leetcode" className="logo" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
